import React from 'react';
import { useTemperatureUnit } from '../../contexts/TemperatureUnitContext';

const convertToFahrenheit = (celsius) => {
  return (celsius * 9/5) + 32;
};

const formatTemperature = (temp, unit) => {
  if (temp === undefined || temp === null) return '';
  const value = unit === 'F' ? convertToFahrenheit(temp) : temp;
  return `${value.toFixed(1)}°${unit}`;
};

const formatTemperatureDifference = (tempDiff, unit) => {
  if (tempDiff === undefined || tempDiff === null) return '';
  const value = unit === 'F' ? (tempDiff * 9/5) : tempDiff;
  return value.toFixed(1);
};

const TemperatureDisplay = ({ 
  temperature, 
  forecastHours, 
  temperatureComparisonText,
  minTemp,
  maxTemp 
}) => {
  const { unit } = useTemperatureUnit();

  // Extract the numeric value from the comparison text if it exists
  let modifiedComparisonText = temperatureComparisonText;
  if (temperatureComparisonText) {
    const matches = temperatureComparisonText.match(/(\d+\.?\d*)/);
    if (matches) {
      const originalDiff = parseFloat(matches[0]);
      const convertedDiff = formatTemperatureDifference(originalDiff, unit);
      modifiedComparisonText = temperatureComparisonText.replace(
        matches[0],
        convertedDiff
      );
    }
  }

  return (
    <div className="space-y-3">
      {/* Component-scoped delight: the big temperature reveal gets a subtle
          fade + scale on first mount. Matches the .result-card vibe in
          index.css (the typeset agent owns that file, so we ship the
          equivalent locally). 360ms because first-reveal can go up to 500ms. */}
      <style>{`
        .temp-reveal {
          opacity: 1;
          transform: scale(1);
          transition:
            opacity 360ms cubic-bezier(0.23, 1, 0.32, 1),
            transform 360ms cubic-bezier(0.23, 1, 0.32, 1);
        }
        @starting-style {
          .temp-reveal {
            opacity: 0;
            transform: scale(0.96);
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .temp-reveal {
            transition-duration: 0ms;
          }
        }
      `}</style>
      {temperature !== undefined && (
        <div>
          <p className="temp-reveal text-4xl font-light text-gray-900 dark:text-gray-50 flex items-center gap-3">
            {formatTemperature(temperature, unit)}
            {forecastHours > 0 && <span className="text-sm">({forecastHours}h forecast)</span>}
            {modifiedComparisonText && forecastHours === 0 && (
              <span className="text-sm text-gray-700 dark:text-gray-300">
                ({modifiedComparisonText})
              </span>
            )}
          </p>
        </div>
      )}

      <div className="flex gap-3 text-sm text-gray-700 dark:text-gray-300">
        <span>High: {formatTemperature(maxTemp, unit)}</span>
        <span>Low: {formatTemperature(minTemp, unit)}</span>
      </div>
    </div>
  );
};

export default TemperatureDisplay;